$(function () {
    const manageAlertMessage = function () {

        $('.alert-message-wrapper').on('click', function () {
            $(this).addClass('hide');
        });
    }

    manageAlertMessage();
});